import { Coins } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { HomeCardLayout } from "@/campaigns";
import type { JackpotCampaign } from "@/campaigns/modules/jackpot/types";
import { CompactCampaignCard } from "@/components/campaign-card/campaign-card-compact";

/**
 * Home-feed card — a thin wrapper around the shared `CompactCampaignCard`. The hook line is every
 * pot added up — the stream's server-formatted `total`, so it reads exactly like the pots. No pot count on the image: it added clutter, not information,
 * at that stage. Nothing type-specific beyond that one string: the card stays the same card as
 * every other campaign type's.
 */
export const JackpotHomeCard = ({
  jackpotCampaign,
  layout,
}: {
  jackpotCampaign: JackpotCampaign;
  layout: HomeCardLayout;
}) => {
  const { t } = useTranslation();
  const total = jackpotCampaign.total;

  return (
    <CompactCampaignCard
      campaign={jackpotCampaign.campaign}
      typeLabel={t("campaign.typeJackpot", "Jackpot")}
      typeIcon={<Coins />}
      hookValue={total?.display ?? null}
      hookLabel={t("jackpot.totalPots", "Jackpots total")}
      layout={layout}
    />
  );
};
